import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useStep} from '../hooks/useStep.ts';
import {useStepsSelection} from '../hooks/useStepsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {Step} from '../types.ts';

export const EditPage = () => {

    const {id: playbookId, phaseId, stepId} = useParams();

    if (typeof playbookId === 'undefined') {
        throw new Error('playbookId (from route param :id) is required parameter');
    }

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId (from route param :phaseId) is required parameter');
    }

    if (typeof stepId === 'undefined') {
        throw new Error('stepId (from route param :stepId) is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/playbooks/${playbookId}/phases/${phaseId}/steps/${stepId}`);
    }

    const {
        record: step,
        updateRecord,
    } = useStep(stepId);

    const {handleClearSelection} = useStepsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!step) {
        return <PlatformLoader message='Loading step...Please wait'/>;
    }

    // Pin route-scope IDs on the record before editing so the mutation always
    // carries the authoritative phaseId / playbookId from the URL.
    const seededStep = {
        ...step,
        playbookId,
        phaseId,
    } as Step;


    return (
        <FormPageLayout
            title={seededStep.displayName || seededStep.name || seededStep.id}
            pageNavigation={<EditPageNavigation component={seededStep}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={seededStep}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        {/*
                          Reserved for future nested detail (e.g. step execution
                          history, input/output preview). Keep the column so the
                          view-mode layout stays consistent with other EditPages.
                        */}
                        <SimplePageContentWrapper>
                            <></>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={seededStep}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
